//------------------------------------
// create changed campaign note entry
//------------------------------------
export default function createChangedCampaignNoteEntry({
  campaign_note_updated_at = '', // campaign note name (updated_at timestamp)
  id = null, // for character-campaign-note updates/deletes (character-campaign-note id) / will be temp-id for new campaign note (tracking only)
  action = '', // 'ADD', 'UPDATE', 'DELETE'
  payload = {},
} = {}) {
  //----------------------------------------------------------------------------------------
  // basic validation - campaign_note_name and action are required for a valid change entry
  //----------------------------------------------------------------------------------------
  if (!campaign_note_updated_at || !action) {
    throw new Error('Invalid input: campaign_note_updated_at and action are required')
  }
  //--------------------------------------
  // extract payload fields with defaults
  //--------------------------------------
  const {
    character = null, // for new character_count (character id)
    updated_at = '',
    note = '',
  } = payload || {}
  //---------------------------------------------
  // resolve ids (explicit null if not provided)
  //---------------------------------------------
  const resolvedCharacterId = character ?? null
  //--------------------------------------------------------------------------
  // build output object progressively with clear intent for each action type
  //--------------------------------------------------------------------------
  const out = {
    campaign_note_updated_at,
    action,
  }
  //---------------------------------------------------------------------
  // for ADD & UPDATE: include payload object describing editable fields
  //---------------------------------------------------------------------
  if (action === 'ADD' || action === 'UPDATE') {
    const outPayload = {
      updated_at,
      note,
    }
    //---------------------------------------------------
    // for ADD: also include character id inside payload
    //---------------------------------------------------
    if (action === 'ADD') {
      outPayload.character = resolvedCharacterId
    }
    //-------------------------------------
    // assign constructed payload to output
    //--------------------------------------
    out.payload = outPayload
  }
  //-----------------------------------------------------------------------------------
  // UPDATE & DELETE: id = character-count id
  // ADD: id = temp id for tracking (actual character-id + static count-id provided inside payload for server-side creation)
  //-----------------------------------------------------------------------------------
  if (id != null) {
    out.id = id
  }
  //----------------
  // return results
  //----------------
  return out
}
